import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';
import { PartialUiConfiguration } from '~/app/market-config/models/car-confi-ui-configuration';

const q6: PartialCarConfiguration = {
	combinations: ['trimLine', 'equipmentPackages', 'packages', 'paint', 'rims', 'interiorPackages', 'steeringWheels'],
	summaryFooterCta: {
		description: 'Probefahrt vereinbaren',
		labelText: 'Probefahrt vereinbaren',
		target: '_blank',

		icon: 'test-drive',
		trackingName: 'testdrive',
		url: 'https://www.audi.ch/ch/web/de/neuwagen/layer_landing_pages/probefahrt-konfigurator.html',
	},
};

const sq6etron: PartialCarConfiguration = {
	...q6,
};

const q6etron: PartialCarConfiguration = {
	...q6,
};

const q6etron_ui: PartialUiConfiguration = {
	showAccessoriesInclusive: false,
};

const sq6etron_ui: PartialUiConfiguration = {
	showAccessoriesInclusive: false,
};

export { q6etron, q6etron_ui, sq6etron, sq6etron_ui };
